import Vue from 'vue';
import CryptoJS from 'crypto-js';
import qs from 'qs'
export const Storage = {
  set: (key, data) => {
    window.localStorage.setItem(key, JSON.stringify(data));
  },
  get: (key) => {
    const value = JSON.parse(window.localStorage.getItem(key));
    return value;
  },
  remove: (key) => {
    window.localStorage.removeItem(key);
  },
  setSession: (key, data) => {
    window.sessionStorage.setItem(key, JSON.stringify(data));
  },
  getSession: (key) => {
    const value = JSON.parse(window.sessionStorage.getItem(key));
    return value;
  },
  removeSession: (key) => {
    window.sessionStorage.removeItem(key);
  },
  clearSession: () => {
    sessionStorage.clear();
  },
  clear: () => {
    sessionStorage.clear();
    localStorage.clear();
  },
};
export function getTaskModel(item, isDynamic) {
  let str = ''
  let _this = Vue.prototype
  let project = item.project // 项目信息
  let title = item.task ? `<span class="message-mixin-task message-click-task clickItem ${item.task.edit_permission ? 'isRealTask' : ''}">${item.task.task_name}</span>` : '' // 任务名称，判断是否有编辑权限
  let nothing = `<span class="message-mixin-tip">无</span>`

  // 根据action取出模板渲染
  switch (item.raw_data.action) {
    /*
      ----------------------------------  项目 -------------------------
    */
    case 'create_project': // `创建项目 xxx`
      str = `<span class="message-mixin-tip">创建了项目</span><span class="message-mixin-task message-click-project clickItem">${project.title}</span>`
      break
    case 'update_project_name': // `将项目名称修改为 xxx`
      str = `<span class="message-mixin-tip">将项目名称修改为</span>
            <span class="message-mixin-task">${item.raw_data.changed_data.new_data}</span>
      `
      break
    case 'update_project_content': // `将项目描述修改为 xxx`
      str = `<span class="message-mixin-tip">将项目描述修改为</span>
            <span class="message-mixin-task rich-message">${item.raw_data.changed_data.new_data || nothing}</span>`
      break
    case 'upload_project_attachment': // `上传了项目文件 "xxx"`
      str = `
            <span class="message-mixin-tip">上传了项目文件</span>
            <span class="message-mixin-task message-mixin-file">"${_this.fileSuffix(item.raw_data.changed_data.add_data[0].attachment_name)}"</span>`
      break
    case 'delete_project_attachment': // `删除了项目文件 "xxx"`
      str = `
            <span class="message-mixin-tip">删除了项目文件</span>
            <span class="message-mixin-task message-mixin-file">"${_this.fileSuffix(item.raw_data.changed_data.delete_data[0].attachment_name)}"</span>`
      break
    case 'add_custom_field': //添加了字段 xxx
      str = `<span class="message-mixin-tip">添加了字段</span><span class="message-mixin-task">${item.raw_data.changed_data.add_data.join(',')}</span>`
      break
    case 'archived_project': // `归档项目 xxx`
      str = `<span class="message-mixin-tip">归档项目</span><span class="message-mixin-task">${project.title}</span>`
      break
    case 'delete_project': // `删除项目 xxx`
      str = `<span class="message-mixin-tip">删除项目</span><span class="message-mixin-task del-line">${project.title}</span>`
      break
    case 'active_project': // `激活项目 xxx`
      str = `<span class="message-mixin-tip">激活项目</span><span class="message-mixin-task message-click-project clickItem">${project.title}</span>`
      break
    case 'freeze_project': // `冻结项目 xxx`
      str = `<span class="message-mixin-tip">冻结项目</span>
             <span class="message-mixin-task">${project.title}</span>`
      break
    case 'update_project_members':
      // 同时添加和移除成员
      // `邀请了 [xxx] 加入项目 xxx , 将 [xxx] 移出项目`
      if (item.raw_data.changed_data.add_data.length > 0 && item.raw_data.changed_data.delete_data.length > 0) {
        str = `<span class="message-mixin-tip">邀请了</span><span class="message-mixin-task">${item.raw_data.changed_data.add_data.map((res) => res.realname).join('、') || ''}</span><span class="message-mixin-tip">加入项目</span>,<span class="message-mixin-tip">将</span><span class="message-mixin-task">${item.raw_data.changed_data.delete_data.map((res) => res.realname).join('、') || ''}</span><span class="message-mixin-tip">移出项目</span>`
      } else if (item.raw_data.changed_data.add_data.length > 0) {
        // `邀请了 [xxx] 加入项目`
        str = `<span class="message-mixin-tip">邀请了</span><span class="message-mixin-task">${item.raw_data.changed_data.add_data.map((res) => res.realname).join('、') || ''}</span><span class="message-mixin-tip">加入项目</span>`
      } else if (item.raw_data.changed_data.delete_data.length > 0) {
        // `将[xxx] 移出项目`
        str = `<span class="message-mixin-tip">将</span><span class="message-mixin-task">${item.raw_data.changed_data.delete_data.map((res) => res.realname).join('、') || ''}</span><span class="message-mixin-tip">移出项目</span>`
      }
      break
    case 'update_project_member_role': // `将 xxx 修改为 管理员`
      str = `
            <span class="message-mixin-tip">将</span><span class="message-mixin-task">${item.raw_data.changed_data.member_user.realname || ''}</span>
            <span class="message-mixin-tip">修改为</span><span class="message-mixin-task">${item.raw_data.changed_data.new_data}</span>`
      break
    case 'update_project': // `更新项目 xxx`
      str = `<span class="message-mixin-tip">更新项目</span><span class="message-mixin-task message-click-project clickItem">${project.title}</span>`
      break
    /*
      ----------------------------------  跨团队-项目 -------------------------
    */
    case 'cross_project_approval_status_passed': // 跨团队项目 xxx 审核通过
      str = `
            <span class="message-mixin-tip">跨团队项目</span>
            <span class="message-mixin-task message-click-cross clickItem">${item.cross_projects.project_name}</span>
            <span class="message-mixin-tip">审核通过</span>
      `
      break
    case 'cross_project_approval_status_failed': // 跨团队项目 xxx 审核未通过
      str = `
            <span class="message-mixin-tip">跨团队项目</span>
            <span class="message-mixin-task message-click-cross-not-pass clickItem">${item.cross_projects.project_name}</span>
            <span class="message-mixin-tip">审核未通过</span>
      `
      break
    case 'cross_project_create_subproject': //  创建了项目 xxx
      str = `
            <span class="message-mixin-tip">创建了项目</span>
            <span class="message-mixin-task message-click-cross clickItem">${item.project.title}</span>
      `
      break
    case 'cross_project_add_subproject': //  添加了项目 xxx 进入跨团队
      str = `
            <span class="message-mixin-tip">添加了项目</span>
            <span class="message-mixin-task message-click-cross clickItem">${item.project.title}</span>
            <span class="message-mixin-tip">进入跨团队</span>
      `
      break
    case 'cross_project_delete_subproject': //  移除了项目 xxx
      str = `
            <span class="message-mixin-tip">移除了项目</span>
            <span class="message-mixin-task message-click-cross clickItem">${item.project.title}</span>
      `
      break
    case 'update_cross_project_name': //  将跨团队项目名称修改为 xxx
      str = `
            <span class="message-mixin-tip">将跨团队项目名称修改为</span>
            <span class="message-mixin-task">${item.raw_data.changed_data.new_data}</span>
      `
      break
    case 'update_cross_project_overview': //  将跨团队描述修改为 xxx
      str = `
            <span class="message-mixin-tip">将跨团队描述修改为</span>
            <span class="message-mixin-task rich-message">${item.raw_data.changed_data.new_data}</span>
      `
      break
    case 'update_cross_project_members':
      // 同时添加和移除成员
      // `邀请了 [xxx] 加入跨团队项目 xxx , 将 [xxx] 移出项目`
      if (item.raw_data.changed_data.add_data.length > 0 && item.raw_data.changed_data.delete_data.length > 0) {
        str = `<span class="message-mixin-tip">邀请了</span><span class="message-mixin-task">${item.raw_data.changed_data.add_data.map((res) => res.realname).join('、') || ''}</span><span class="message-mixin-tip">加入跨团队项目</span>,<span class="message-mixin-tip">将</span><span class="message-mixin-task">${item.raw_data.changed_data.delete_data.map((res) => res.realname).join('、') || ''}</span><span class="message-mixin-tip">移出跨团队项目</span>`
      } else if (item.raw_data.changed_data.add_data.length > 0) {
        // `邀请了 [xxx] 加入跨团队项目`
        str = `<span class="message-mixin-tip">邀请了</span><span class="message-mixin-task">${item.raw_data.changed_data.add_data.map((res) => res.realname).join('、') || ''}</span><span class="message-mixin-tip">加入跨团队项目</span>`
      } else if (item.raw_data.changed_data.delete_data.length > 0) {
        // `将[xxx] 移出跨团队项目`
        str = `<span class="message-mixin-tip">将</span><span class="message-mixin-task">${item.raw_data.changed_data.delete_data.map((res) => res.realname).join('、') || ''}</span><span class="message-mixin-tip">移出跨团队项目</span>`
      }
      str += `<span class="message-mixin-task message-click-cross clickItem">${item.cross_projects.project_name}</span>`
      break
    case 'update_cross_project_member_role': //  将 xxx 修改为跨团队项目 xxx
      str = `
            <span class="message-mixin-tip">将</span>
            <span class="message-mixin-task">${item.raw_data.changed_data.member_user.realname || ''}</span>
            <span class="message-mixin-tip">修改为跨团队项目</span>
            <span class="message-mixin-task">${item.raw_data.changed_data.new_data}</span>`
      break
    case 'active_cross_project': //  激活跨团队项目 xxx
      str = `
            <span class="message-mixin-tip">激活跨团队项目</span>
            <span class="message-mixin-task message-click-cross clickItem">${item.cross_projects.project_name}</span>
      `
      break
    case 'archived_cross_project': //  归档跨团队项目 xxx
      str = `
            <span class="message-mixin-tip">归档跨团队项目</span>
            <span class="message-mixin-task message-click-cross clickItem">${item.cross_projects.project_name}</span>
      `
      break
    case 'freeze_cross_project': //  冻结跨团队项目 xxx
      str = `
            <span class="message-mixin-tip">冻结跨团队项目</span>
            <span class="message-mixin-task message-click-cross clickItem">${item.cross_projects.project_name}</span>
      `
      break
    case 'delete_cross_project': //  删除跨团队项目 xxx
      str = `
            <span class="message-mixin-tip">删除跨团队项目</span>
            <span class="message-mixin-task message-click-cross clickItem">${item.cross_projects.project_name}</span>
      `
      break
    /*
      ----------------------------------  跨团队-里程碑 -------------------------
    */
    case 'create_project_milestone': // `创建里程碑 xxx`
      str = `
            <span class="message-mixin-tip">创建里程碑</span>
            <span class="message-mixin-task message-click-cross clickItem">${item.cross_projects_milestone.milestone_name}</span>`
      break
    case 'delete_project_milestone': // `删除里程碑 xxx`
      str = `
            <span class="message-mixin-tip">删除里程碑</span>
            <span class="message-mixin-task message-click-cross clickItem">${item.cross_projects_milestone.milestone_name}</span>`
      break
    case 'update_project_milestone_name': // `将里程碑 xxx 名称修改为 xxx`
      str = `<span class="message-mixin-tip">将里程碑</span>
        <span class="message-mixin-task message-click-cross clickItem">${item.raw_data.changed_data.old_data}</span>
        <span class="message-mixin-tip">名称修改为</span>
        <span class="message-mixin-task message-click-milestone clickItem">${item.raw_data.changed_data.new_data}</span>`
      break
    case 'update_project_milestone_end_date': // `将里程碑 xxx 完成时间修改为 xxx`
      str = `<span class="message-mixin-tip">将里程碑</span>
        <span class="message-mixin-task message-click-cross clickItem">${item.cross_projects_milestone.milestone_name}</span>
        <span class="message-mixin-tip">完成时间修改为</span>
        <span class="message-mixin-task">${_this.resetTime(item.raw_data.changed_data.new_data)}</span>`
      break
    case 'update_project_milestone_description': // `将里程碑 xxx 描述修改为 xxx`
      str = `<span class="message-mixin-tip">将里程碑</span>
        <span class="message-mixin-task message-click-cross clickItem">${item.cross_projects_milestone.milestone_name}</span>
        <span class="message-mixin-tip">描述修改为</span>
        <span class="message-mixin-task rich-message">${item.raw_data.changed_data.new_data || nothing}</span>`
      break
    case 'update_project_milestone_attachment': // 判断是否上传文件还是删除文件
      if (item.raw_data.changed_data?.add_data[0]) {
        // `在里程碑 xxx 上传附件 "xxx"`
        str = `
        <span class="message-mixin-tip">在里程碑</span>
        <span class="message-mixin-task message-click-milestone clickItem">${item?.cross_projects_milestone?.milestone_name}</span>
        <span class="message-mixin-tip">上传附件</span>
        <span class="message-mixin-task message-mixin-file">"${_this.fileSuffix(item.raw_data?.changed_data?.add_data[0]?.attachment_name)}"</span>`
      } else if (item.raw_data.changed_data?.delete_data[0]) {
        // `在里程碑 xxx 删除附件 "xxx"`
        str = `
        <span class="message-mixin-tip">在里程碑</span>
        <span class="message-mixin-task message-click-milestone clickItem">${item?.cross_projects_milestone?.milestone_name}</span>
        <span class="message-mixin-tip">删除附件</span>
        <span class="message-mixin-task message-mixin-file">"${_this.fileSuffix(item.raw_data?.changed_data?.delete_data[0]?.attachment_name)}"</span>`
      }
      break
    case 'update_project_milestone_status': // tem.raw_data.changed_data.old_data 这个字段返回 0 和 1 有可能是字符串，所以需要转换
      let Old = Boolean(Number(item.raw_data.changed_data.old_data)) ? '已完成' : '未完成'
      let New = Boolean(Number(item.raw_data.changed_data.new_data)) ? '已完成' : '未完成'
      // `将里程碑 xxx 的状态 [xxx] 修改为 [xxx] `
      str = `
        <span class="message-mixin-tip">将里程碑</span>
        <span class="message-mixin-task message-click-milestone clickItem">${item?.cross_projects_milestone?.milestone_name}</span>
        <span class="message-mixin-tip">的状态</span>
        <span class="message-mixin-task">[${Old}]</span>
        <span class="message-mixin-tip">修改为</span>
        <span class="message-mixin-task">[${New}]</span>`
      break
    /*
      ----------------------------------  清单 -------------------------
    */
    case 'add_task_list': // `创建了任务清单 xxx`
      str = `<span class="message-mixin-tip">创建了任务清单</span>
             <span class="message-mixin-task">${item.task_list ? item.task_list.title : ''}</span>`
      break
    case 'update_task_list_name': // `将任务清单 xxx 名称修改为 xxx`
      str = `
            <span class="message-mixin-tip">将任务清单</span>
            <span class="message-mixin-task">${item.raw_data.changed_data.old_data}</span>
            <span class="message-mixin-tip">名称修改为</span>
            <span class="message-mixin-task">${item.raw_data.changed_data.new_data}</span>`
      break
    case 'move_task_list': // `对清单进行重新排序`
      str = `
            <span class="message-mixin-tip">对清单进行重新排序</span>`
      break
    case 'delete_task_list': // `将任务清单 xxx 移到回收站`
      str = `
            <span class="message-mixin-tip">将任务清单</span>
            <span class="message-mixin-task">${item.task_list ? item.task_list.title : ''}</span>
            <span class="message-mixin-tip">移到回收站</span>`
      break
    case 'restore_task_list': // `恢复了任务清单 xxx`
      str = `
            <span class="message-mixin-tip">恢复了任务清单</span>${item.task_list.title}`
      break
    case 'update_task_list': // `更新任务清单 xxx `
      str = `
      <span class="message-mixin-tip">更新任务清单</span>
      <span class="message-mixin-task">${item.task_list ? item.task_list.title : ''}</span>`
      break
    /*
      ----------------------------------  任务 -------------------------
      */
    case 'add_task': // `新建任务 xxx`
      if (item.raw_data.desc === '指派') {
        str = `<span class="message-mixin-tip">将任务</span>${title}<span class="message-mixin-tip">指派给您</span>`
      } else {
        str = `<span class="message-mixin-tip">创建了任务</span>${title}`
      }
      break
    case 'delete_task': // `将任务 xxx 移至回收站`
      str = `<span class="message-mixin-tip">将任务</span>
      <span class="message-mixin-task del-line">${item.task.task_name}</span>
      <span class="message-mixin-tip">移至回收站</span>`
      break
    case 'restore_task': // `恢复了任务 xxx `
      str = `<span class="message-mixin-tip">恢复了任务</span>${title}`
      break
    case 'task_comment': // `发表了评论`
      str = `<span class="message-mixin-tip">发表了评论</span>`
      break
    case 'task_replay_comment': // `回复了您的评论`
      str = `<span class="message-mixin-tip">回复了您的评论</span>`
      break
    case 'complete_associated_task': // `完成了 xxx 的前置任务 xxx`
      str = `
          <span class="message-mixin-tip">完成了前置任务</span>
          <span class="message-mixin-task message-click-task clickItem">${item.raw_data.changed_data.pre_task.task_name}</span>`
      break
    case 'unfinished_associated_task': // `完成了 xxx 的前置任务 xxx`
      str = `
          <span class="message-mixin-tip">修改前置任务</span>
          <span class="message-mixin-task message-click-task clickItem">${item.raw_data.changed_data.pre_task.task_name}</span>
          <span class="message-mixin-tip">状态为</span>
          <span class="message-mixin-task">[未完成]</span>`
      break
    case 'move_task': // `调整了任务排序 xxx `
      str = `<span class="message-mixin-tip">调整了任务排序</span><span class="message-mixin-task message-click-task clickItem">${item.task.task_name}</span>`
      break
    case 'move_task_cross_task_list':
      str = `
      <span class="message-mixin-tip">将任务</span>
      ${title}
      <span class="message-mixin-tip">从任务清单</span>
      <span class="message-mixin-task">${item.raw_data.changed_data.old_data.title}</span>
      <span class="message-mixin-tip">移动到任务清单</span>
      <span class="message-mixin-task">${item.raw_data.changed_data.new_data.title}</span>
      `
      break
    case 'task_comment_mention':
      str = `
      <span class="message-mixin-tip">在评论中@了你</span>
      `
      break
    case 'update_task_executor_or_member':
    case 'update_task_stage':
    case 'update_task_start_and_end_time':
    case 'update_task': // 更新非自定义字段, changed_data 可能返回多天更新，需要遍历
      item.raw_data.changed_data.forEach((res, index) => {
        if (!res.component_code) {
          // 非自定义字段
          let result = ''
          switch (
            res.field // 字段推送
          ) {
            case 'task_stage': // `将任务状态 [xxx] 修改为 [xxx]` , 进行中 字符替换成未完成
              result = `<span class="message-mixin-tip">将任务状态</span><span class="message-mixin-task">[${res.old_data || ''}]</span><span class="message-mixin-tip">修改为</span><span class="message-mixin-task">[${res.new_data || ''}]</span>`
              result = result.replace('进行中', '未完成')
              break
            case 'task_name': // `的名称 xxx 修改为 xxx`
              result = `
                  <span class="message-mixin-tip">将任务名称修改为</span>
                  <span class="message-mixin-task">${res.new_data || ''}</span>`
              break
            case 'start_time':
              result = `
              <span class="message-mixin-tip">将开始时间修改为</span>
              <span class="message-mixin-task">${!res.new_data ? `<span class="message-mixin-tip">无</span>` : res.new_data} </span>`
              break
            case 'end_time': // 当修改截止日期时数组中会有两个值start_time和end_time, 但是只要渲染一条，所以只要判断end_time就好， `将完成日期修改为 xxx`
              // let s = item.raw_data.changed_data.find((res) => res.field === 'start_time')
              // if (!s) return
              // let start_time = item.raw_data.changed_data.find((res) => res.field === 'start_time').new_data
              // let end_time = res.new_data
              // result = `
              // <span class="message-mixin-tip">将完成日期修改为</span>
              // <span class="message-mixin-task">${!start_time && !end_time ? `<span class="message-mixin-tip">无</span>` : `${_this.resetTime(start_time)} - ${_this.resetTime(end_time)}`} </span>`
              result = `
              <span class="message-mixin-tip">将结束时间修改为</span>
              <span class="message-mixin-task">${!res.new_data ? `<span class="message-mixin-tip">无</span>` : res.new_data} </span>`
              break
            case 'executor': // 执行人判断三种状态，新增、删除、修改
              if (res.old_data && res.old_data.uid && (!res.new_data || !res.new_data.uid)) {
                // 当old_data有值时和new_data为空则判断为删除了执行人，`将任务 xxx 修改为 待认领`
                result = `
                <span class="message-mixin-tip">将任务</span>
                ${title}
                <span class="message-mixin-tip">修改为</span>
                <span class="message-mixin-task">待认领</span>
                `
              } else if (res.old_data && res.old_data.uid) {
                // 修改 `将任务执行人 xxx 修改为 xxx`
                result = `<span class="message-mixin-tip">将任务执行人</span><span class="message-mixin-task">${res.old_data ? res.old_data.realname || '' : ''}</span><span class="message-mixin-tip">修改为</span><span class="message-mixin-task">${res.new_data.realname || ''}</span>`
              } else {
                // 新增 `将 xxx 设置为任务 xxx 的执行人`
                result = `
                <span class="message-mixin-tip">将</span>
                <span class="message-mixin-task">${res.new_data.realname || ''}</span>
                <span class="message-mixin-tip">设置为执行人</span>
                `
              }
              break
            case 'sort_rule_id':
              // `将优先级从 xxx 修改为 xxx`
              result = `<span class="message-mixin-tip">将优先级从</span><span class="message-mixin-task">[${res.old_data || ''}]</span><span class="message-mixin-tip">修改为</span><span class="message-mixin-task">[${res.new_data || ''}]</span>`
              break
            case 'task_members':
              // 判断同时添加和删除成员
              if (res.add_data.length > 0 && res.delete_data.length > 0) {
                result = `
                <span class="message-mixin-tip">将</span>
                <span class="message-mixin-task">${res.add_data.map((res) => res.realname).join('、') || ''}</span>
                <span class="message-mixin-tip">设置为参与人</span>
                <span class="message-mixin-tip">将</span>
                <span class="message-mixin-task">${res.delete_data.map((res) => res.realname).join('、') || ''}</span>
                <span class="message-mixin-tip">移出任务</span>
                ${title}
                `
              } else if (res.add_data.length > 0) {
                result = `
                <span class="message-mixin-tip">将</span>
                <span class="message-mixin-task">${res.add_data.map((res) => res.realname).join('、') || ''}</span>
                <span class="message-mixin-tip">设置为参与人</span>
                `
              } else if (res.delete_data.length > 0) {
                result = `
                <span class="message-mixin-tip">将</span>
                <span class="message-mixin-task">${res.delete_data.map((res) => res.realname).join('、') || ''}</span>
                <span class="message-mixin-tip">移出任务</span>
                ${title}`
              }
              break
          }
          result ? (str += `<p class="message-line-box">${result}</p>`) : ''
        } else {
          let result = Vue['$' + res.component_code].getMessage(res, item)
          result ? (str += `<p class="message-line-box">${result}</p>`) : ''
        }
      })
  }
  let arr = ['update_task_executor_or_member', 'update_task_stage', 'update_task_start_and_end_time', 'update_task']
  if (!(arr.indexOf(item.raw_data.action) > -1)) {
    str = `<p class="message-line-box">${str}</p>`
  }
  return str
}
export const Cookie = {
  set: (key, value, day) => {
    const nowDate = new Date();
    nowDate.setDate(nowDate.getDate() + day);
    document.cookie = `${key}=${value};expires=${nowDate};path=${window.location.pathname}`;
  },
  get: (key) => {
    // 读取cookie值
    const str = document.cookie;
    const arr = str.split('; ');
    let arr2 = [];
    const arrjson = {};
    for (let i = 0; i < arr.length; i++) {
      arr2 = arr[i].split('=');
      arrjson[arr2[0]] = arr2[1];
    }
    return arrjson[key];
  },
  remove: (key) => {
    if (Cookie.get(key)) {
      Cookie.set(key, '', -1); // -1 值得是前一天的cookie值
    }
  },
};

export function parseTime(time, cFormat) { // 时间格式化
  if (arguments.length === 0) {
    return null;
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  let date;
  if (typeof time === 'object') {
    date = time;
  } else {
    if ((`${time}`).length === 10) time = parseInt(time) * 1000;
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  };
  const timeStr = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key];
    if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1];
    if (result.length > 0 && value < 10) {
      value = `0${value}`;
    }
    return value || 0;
  });
  return timeStr;
}

export const VConsole = () => {
  const VConsoleUrl = 'https://cdn.bootcdn.net/ajax/libs/vConsole/3.4.1/vconsole.min.js';
  const createScript = function (url) {
    const oScript = document.createElement('script');
    oScript.type = 'text/javascript';
    oScript.async = true;
    oScript.src = url;
    document.body.appendChild(oScript);
  };
  process.env.MY_ENV !== 'build' && createScript(VConsoleUrl);
};

// 递归菜单
export const findParent = (menu, id) => {
  for (let i = 0; i < menu.length; i++) {
    if (menu[i].children && menu[i].children.length != 0) {
      for (let j = 0; j < menu[i].children.length; j++) {
        if (menu[i].children[j].id * 1 == id * 1) {
          return menu[i];
        }
        if (menu[i].children[j] && menu[i].children[j].children && menu[i].children[j].children
          .length != 0) {
          findParent(menu[i].children[j].children, id);
        }
      }
    }
  }
};

export const findParentID = (menu, id) => {
  if (menu && menu.length > 0) {
    for (let i = 0; i < menu.length; i++) {
      if (menu[i].id == id) {
        return menu[i];
      }
      if (menu[i].children) {
        return findParentID(menu[i].children, id);
      }
    }
  }
};


/**
 * 判断路由是否相等
 */
export const diff = (obj1, obj2) => {
  delete obj1.close;
  const o1 = obj1 instanceof Object;
  const o2 = obj2 instanceof Object;
  if (!o1 || !o2) {
    /*  判断不是对象  */
    return obj1 === obj2;
  }

  if (Object.keys(obj1).length !== Object.keys(obj2).length) {
    return false;
    // Object.keys() 返回一个由对象的自身可枚举属性(key值)组成的数组,例如：数组返回下表：let arr = ["a", "b", "c"];console.log(Object.keys(arr))->0,1,2;
  }

  for (const attr in obj1) {
    const t1 = obj1[attr] instanceof Object;
    const t2 = obj2[attr] instanceof Object;
    if (t1 && t2) {
      return diff(obj1[attr], obj2[attr]);
    }
    if (obj1[attr] !== obj2[attr]) {
      return false;
    }
  }
  return true;
};
/**
 * 浏览器判断是否全屏
 */
export const fullscreenToggel = () => {
  if (fullscreenEnable()) {
    exitFullScreen();
  } else {
    reqFullScreen();
  }
};
/**
 * esc监听全屏
 */
export const listenfullscreen = (callback) => {
  function listen() {
    callback()
  }
  document.addEventListener("fullscreenchange", function () {
    listen();
  });
  document.addEventListener("mozfullscreenchange", function () {
    listen();
  });
  document.addEventListener("webkitfullscreenchange", function () {
    listen();
  });
  document.addEventListener("msfullscreenchange", function () {
    listen();
  });
};
/**
 * 浏览器判断是否全屏
 */
export const fullscreenEnable = () => {
  var isFullscreen = document.fullscreenEnabled ||
    window.fullScreen ||
    document.mozFullscreenEnabled ||
    document.webkitIsFullScreen;
  return isFullscreen;
}

/**
 * 浏览器全屏
 */
export const reqFullScreen = () => {
  if (document.documentElement.requestFullScreen) {
    document.documentElement.requestFullScreen();
  } else if (document.documentElement.webkitRequestFullScreen) {
    document.documentElement.webkitRequestFullScreen();
  } else if (document.documentElement.mozRequestFullScreen) {
    document.documentElement.mozRequestFullScreen();
  }
};
/**
 * 浏览器退出全屏
 */
export const exitFullScreen = () => {
  if (document.documentElement.requestFullScreen) {
    document.exitFullScreen();
  } else if (document.documentElement.webkitRequestFullScreen) {
    document.webkitCancelFullScreen();
  } else if (document.documentElement.mozRequestFullScreen) {
    document.mozCancelFullScreen();
  }
};
export const treeToArray = (
  data,
  expandAll,
  parent = null,
  level = null
) => {
  let tmp = [];
  Array.from(data).forEach(function (record) {
    if (record._expanded === undefined) {
      Vue.set(record, "_expanded", expandAll);
    }
    let _level = 1;
    if (level !== undefined && level !== null) {
      _level = level + 1;
    }
    Vue.set(record, "_level", _level);
    // 如果有父元素
    if (parent) {
      Vue.set(record, "parent", parent);
    }
    tmp.push(record);
    if (record.child && record.child.length > 0) {
      const child = treeToArray(record.child, expandAll, record, _level);
      tmp = tmp.concat(child);
    }
  });
  return tmp;
}
// des加密
// str 加密字符， aStrKey 秘钥， ivstr 秘钥偏移量
export const Encrypt3Des = (str, aStrKey, ivstr) => {
  // 加密
  const KeyHex = CryptoJS.enc.Utf8.parse(aStrKey);
  const encrypted = CryptoJS.TripleDES.encrypt(str, KeyHex, {
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
    iv: CryptoJS.enc.Utf8.parse(ivstr)
  });
  const hexstr = encrypted.ciphertext.toString().toUpperCase();
  (hexstr);
  return hexstr;
};
export const Decrypt3Des = (str, aStrKey, ivstr) => {
  // 解密
  const KeyHex = CryptoJS.enc.Utf8.parse(aStrKey);
  // 因为我们加密的时候用到的16进制字符串，需要进行转换
  // 第一步把16进制字符串转为WordArray格式
  const WordArray = CryptoJS.enc.Hex.parse(str);
  // 第二步把WordArray再转为base64的字符串
  const base64str = CryptoJS.enc.Base64.stringify(WordArray);
  // 第三步再进行解密
  const decrypted = CryptoJS.TripleDES.decrypt(base64str, KeyHex, {
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
    iv: CryptoJS.enc.Utf8.parse(ivstr)
  });
  return decrypted.toString(CryptoJS.enc.Utf8);
};
// aec加密
const key = CryptoJS.enc.Utf8.parse("1234567890000000"); //16位
const iv = CryptoJS.enc.Utf8.parse("1234567890000000");
export const encryptAec = (word) => {
  let encrypted = "";
  if (typeof word == "string") {
    const srcs = CryptoJS.enc.Utf8.parse(word);
    encrypted = CryptoJS.AES.encrypt(srcs, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
  } else if (typeof word == "object") {
    //对象格式的转成json字符串
    const data = JSON.stringify(word);
    const srcs = CryptoJS.enc.Utf8.parse(data);
    encrypted = CryptoJS.AES.encrypt(srcs, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
  }
  return encrypted.ciphertext.toString();
}
// aes解密
 export const decryptAec = (word) => {
  const encryptedHexStr = CryptoJS.enc.Hex.parse(word);
  const srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
  const decrypt = CryptoJS.AES.decrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  const decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
  return decryptedStr.toString();
 }

 /**
 * 加密 字符串参数
 * @param {Object}} obj
 */
export const stringifyQuery = obj => {
  if(typeof obj === 'string') return obj ? `?${obj}` : ''
  let code = qs.stringify(obj, { strictNullHandling: true })
  if(process.env.NODE_ENV !== 'production') return code ? `?${code}` : ''
  return code ? `?${encryptAec(code)}` : ''
}
/**
 * 解密 解析 字符串参数
 * @param {String}} query
 */
export const parseQuery = query => {
  // 先对query进行解密
  const res = {}
  query = query.trim().replace(/^(\?|#|&)/, '')
  if (!query) {
    return res
  }
  if(process.env.NODE_ENV !== 'production') return qs.parse(query, { strictNullHandling: true })
  // 解密
  query = decryptAec(query);
  return qs.parse(query, { strictNullHandling: true })
}
export const codeMosaic = (phone) => {
  let re = /(\d{3})\d{4}(\d{4})/;
  return phone.replace(re, '$1****$2');
}
export const dateDiff = (star, end) => {
  var date1 = new Date(star);
  var date2 = new Date(end);

  var s1 = date1.getTime(),
    s2 = date2.getTime();
  var total = (s2 - s1) / 1000;


  var day = parseInt(total / (24 * 60 * 60)); //计算整数天数
  //	var afterDay = total - day*24*60*60;//取得算出天数后剩余的秒数
  //	var hour = parseInt(afterDay/(60*60));//计算整数小时数
  //	console.info(hour);
  //	var afterHour = total - day*24*60*60 - hour*60*60;//取得算出小时数后剩余的秒数
  //	var min = parseInt(afterHour/60);//计算整数分
  //	var afterMin = total - day*24*60*60 - hour*60*60 - min*60;//取得算出分后剩余的秒数
  return day;
}

export const myBrowser = () => {
  var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
  var isOpera = userAgent.indexOf("Opera") > -1;
  if (isOpera) {
    return "Opera"
  }; //判断是否Opera浏览器
  if (userAgent.indexOf("Firefox") > -1) {
    return "FF";
  } //判断是否Firefox浏览器
  if (userAgent.indexOf("Chrome") > -1) {
    return "Chrome";
  }
  if (userAgent.indexOf("Safari") > -1) {
    return "Safari";
  } //判断是否Safari浏览器
  if (userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 && !isOpera) {
    return "IE";
  }; //判断是否IE浏览器
}
// 滚动条动画
export const scorllAnimate = (target, fn) => {
  let time = ''
  let step = 0
  clearInterval(time)
  let spee = 10
  time = setInterval(() => {
    if (step < target) {
      step += spee
      fn(step)
      spee += 10
    } else {
      clearInterval(time)
      time = ''
      return
    }
  }, 20);
}
